import { Component, OnInit, HostListener } from '@angular/core';
import { MyserviceService } from '../../provider/myservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as moment from 'moment';
import Swal from 'sweetalert2';
import { report_bill_lang } from "../../language/report_bill";
import * as XLSX from 'xlsx-js-style';


@Component({
  selector: 'app-print-report-bill-excel',
  templateUrl: './print-report-bill-excel.component.html',
  styleUrls: ['./print-report-bill-excel.component.scss']
})
export class PrintReportBillComponentExcel implements OnInit {
  @HostListener('window:afterprint', ['$event'])
  public afterPrintHandler(event) {
    window.close();
    window.stop();
    console.log('Printing finished or canceled.ๅๅๅ');
  }
  total_price = 0;
  total_price_value = '';
  print_datetime = '';
  report = '';
  day: any;
  month: any;
  year: any;
  reports: any;
  isLoading = true;
  lang = localStorage.getItem('lang') == "EN" ? "EN" : "TH";
  language: any;
  type = null;
  date_filter = null;
  constructor(private route: ActivatedRoute, router: Router, private service: MyserviceService, private http: HttpClient) {
    this.language = report_bill_lang[this.lang];
  }

  ngOnInit() {

    this.route.queryParams.subscribe(params => {
      //debugger
      this.date_filter = params['date_filter'];

      if (params['report'] == '1') {
        var x = moment.unix(params['datetime']).locale('th-TH');
        var xy = 0;
        xy = parseInt(x.format('YYYY'));

        if (xy < 2500) {
          xy = xy + 543;
        }

        this.day = parseInt(x.format('DD'));
        this.month = parseInt(x.format('MM'));
        this.year = parseInt(x.format('YYYY'));
        this.print_datetime = x.format('DD MMMM ') + xy.toString();
        this.report = '1';
      }
      else if (params['report'] == '2') {
        var dateString = params['month'] + '-01-' + params['year'];
        var x = moment(dateString, 'MM-DD-YYYY').locale('th-TH');
        var xy = 0;
        xy = parseInt(x.format('YYYY'));

        if (xy < 2500) {
          xy = xy + 543;
        }

        this.day = parseInt(x.format('DD'));
        this.month = parseInt(x.format('MM'));
        this.year = parseInt(x.format('YYYY'));
        this.print_datetime = x.format('MMMM ') + xy.toString();
        console.log(this.print_datetime);
        this.report = '6';
      }
      else if (params['report'] == '3') {
        var dateString = '01-01-' + params['year'];
        var x = moment(dateString, 'MM-DD-YYYY').locale('th-TH');
        var xy = 0;
        xy = parseInt(x.format('YYYY'));

        if (xy < 2500) {
          xy = xy + 543;
        }

        this.day = parseInt(x.format('DD'));
        this.month = parseInt(x.format('MM'));
        this.year = parseInt(x.format('YYYY'));
        this.print_datetime = xy.toString();
        console.log(this.print_datetime);
        this.report = '7';
      }
      else if (params['report'] == '4') {
        this.day = '01';
        this.month = params['month'];
        this.year = params['year'];
        console.log(this.print_datetime);
        this.report = '4';
        this.type = '4';
      }
      else if (params['report'] == '5') {
        this.day = '01';
        this.month = params['month'];
        this.year = params['year'];
        console.log(this.print_datetime);
        this.report = '5';
        this.type = '5';
      }

    });

    this.refresh();
  }

  refresh() {
    this.service.postData({
      type: this.type, report_type: this.report, day: (this.day.toString().length == 1) ? '0' + this.day.toString() : this.day.toString(), month: (this.month.toString().length == 1) ? '0' + this.month.toString() : this.month.toString(), year: this.year,
      date_filter: this.date_filter
    }, "reports-new/get_reports_all_bill").then((result: any) => {
      this.reports = JSON.parse(JSON.stringify(result.data).replace(/\:null/gi, "\:\"\""))

      var formatter = new Intl.NumberFormat('th-TH', {
        style: 'currency',
        currency: 'THB',
      });

      this.http.get('/assets/file-excel/my_excel_file.xlsx', { responseType: 'arraybuffer' })
        .subscribe(async data => {
          const wb = XLSX.read(data, { type: 'array', cellStyles: true });

          // for (let tmb = 0; tmb <= this.reports.length - 1; tmb++) {

          //   var xy = 0;
          //   xy = parseInt(moment(this.reports[tmb].due_date).format('YYYY'));

          //   if (xy < 2500) {
          //     xy = xy + 543;
          //   }

          //   this.reports[tmb].due_date = moment(this.reports[tmb].due_date).format("DD/MM/") + xy;
          //   this.total_price += parseFloat(this.reports[tmb].total_price);
          //   this.reports[tmb].fee_type_price = formatter.format(this.reports[tmb].fee_type_price);

          // }
          this.total_price_value = formatter.format(this.total_price);
          this.isLoading = false;

          var startingMonth = 10;
          //ws_name result = ['test1', 'test2', 'test3']

          // Group the reports by customer_id and place_id
          var reportsByZone = this.reports.reduce((result, report) => {
            if (!result[report.zone_name]) {
              result[report.zone_name] = [];
            }
            result[report.zone_name].push(report);
            return result;
          }, {});

          //reportsByZone ={dda:[]}
          const wo_4: XLSX.WorkBook = XLSX.utils.book_new();


          const loop = Object.keys(reportsByZone)
          for (let ww = 0; ww < loop.length; ww++) {
            const zonename = loop[ww];
            const zone_n = zonename.replace('ชุมชน', '')
            console.log(wb.SheetNames);
            const ws = wb.Sheets[zone_n]
            var uniqueReports = {};

            const reports = reportsByZone[zonename];
            reports.forEach(function (report) {
              var key = report.customer_id + '-' + report.place_id;
              if (!uniqueReports[key]) {
                uniqueReports[key] = [];
              }
              uniqueReports[key].push(report);
            });

            var orderedMonths = Array.apply(null, Array(12)).map(function (_, index) {
              return (startingMonth + index - 1) % 12;
            });

            // Process the grouped reports
            var processedReports = Object.keys(uniqueReports).map(function (key, index) {
              var reports = uniqueReports[key];
              var monthlyData = Array.apply(null, Array(12)).map(function () {
                return {};
              });

              reports.forEach(function (report) {
                var monthIndex = moment(report.pay_datetime).month();
                monthlyData[monthIndex] = {
                  bill_id: report.bill_id,
                  pay_datetime: report.pay_datetime,
                  total_price: report.total_price,
                };
              });

              var flattenedMonthlyData = [].concat.apply(
                [],
                orderedMonths.map(function (monthIndex) {
                  var data = monthlyData[monthIndex];
                  return [
                    data.bill_id || '',
                    data.pay_datetime ? moment(data.pay_datetime).format('DD-MM-YYYY') : '',
                    data.total_price ? data.total_price + 0.0 : '',
                  ];
                }),
              );

              return [
                index + 1,
                reports[0].short_name,
                reports[0].customer_name + ' ' + reports[0].customer_surname,
                reports[0].place_number,
                reports[0].place_road,
                reports[0].tambon_th,
              ].concat(flattenedMonthlyData);
            });

            XLSX.utils.sheet_add_aoa(ws, processedReports, { origin: 'A4' });
            XLSX.utils.book_append_sheet(wo_4, ws, zonename);
            for (var i in ws) {
              console.log(ws[i]);
              if (typeof ws[i] != 'object') continue;
              let cell = XLSX.utils.decode_cell(i);

              ws[i].s = {

                // styling for all cells
                font: {
                  name: 'Angsana New',
                  sz: "16"
                },
                alignment: {
                  vertical: 'center',
                  horizontal: 'center',
                  wrapText: '1', // any truthy value here
                },
                border: {
                  right: {
                    style: 'thin',
                    color: '000000',
                  },
                  left: {
                    style: 'thin',
                    color: '000000',
                  },
                  top: {
                    style: 'thin',
                    color: '000000',
                  },
                  bottom: {
                    style: 'thin',
                    color: '000000',

                  }

                },
              };

              if (cell.c == 6) {
                // first column
                ws[i].s.numFmt = 'DD-MM-YYYY'; // for dates
                ws[i].z = 'DD-MM-YYYY';
              } else {
                ws[i].s.numFmt = '00'; // other numbers
              }

              if (cell.r == 0) {
                // first row
                ws[i].s.border.bottom = {
                  // bottom border
                  style: 'thin',
                  color: '000000',
                };
              }

              if (cell.r == 0) {
                // every other row
                ws[i].s.fill = {
                  // background color
                  patternType: 'solid',
                  fgColor: { rgb: 'b2b2b2' },
                  bgColor: { rgb: 'b2b2b2' },
                };
              }
            }
          }
          console.log(wo_4);




          XLSX.writeFile(wo_4, this.report == '1' ? 'bill_days.xlsx' : this.report == '6' ? 'bill_month.xlsx' : this.report == '7' ? 'bill_year.xlsx' : 'bill_custom.xlsx', { cellStyles: true });
        });




    }, (err) => {
      this.isLoading = false;
      Swal.fire({
        title: this.language.no_internet_alert,
        text: '',
        type: 'error',
        showCancelButton: false,
        showConfirmButton: false,
        timer: 1000
      });
    });
  }

}
